var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yandex-map-component"},[_c('div',{staticClass:"yandex-map-container",attrs:{"id":_vm.containerId}})])}
var staticRenderFns = []

export { render, staticRenderFns }